import { Fragment } from 'react';

import { Container, Divider, Flex, Skeleton, Stack } from '@iwoca/orion';

import { FundingRequirementsShell } from '../FundingRequirementsShell/FundingRequirementsShell';

export const FundingRequirementsPageLoading = () => (
    <div data-testid="funding-requirements-page-loading">
        <FundingRequirementsShell
            sidePanel={
                // ORION-113-GAP off-system: loading styling, not layout
                <Stack gap="comfortable" className="opacity-20">
                    <Skeleton className="h-[32px] w-[200px]" />
                    <Stack gap="tight">
                        <Skeleton className="h-[20px] w-[160px]" />
                        <Skeleton className="h-[40px] w-[220px]" />
                    </Stack>
                    {/* ORION-113-GAP token: no surface for the denim panel */}
                    <Divider className="border-secondary-20" />
                    <Stack gap="tight">
                        <Skeleton className="h-[20px] w-full" />
                        <Skeleton className="h-[20px] w-full" />
                        <Skeleton className="h-[20px] w-full" />
                    </Stack>
                </Stack>
            }
            progressIndicator={<Skeleton className="h-[40px] w-full" />}
            mainContent={
                <Container size="focus">
                    <Stack paddingY="container" gap="comfortable">
                        <Stack gap="tight">
                            <Skeleton className="h-[28px] w-[250px]" />
                            <Skeleton.Text count={2} lastLineWidth={80} />
                        </Stack>
                        <Stack gap="none">
                            {Array.from({ length: 5 }, (_, i) => (
                                <Fragment key={i}>
                                    {i > 0 && <Divider />}
                                    <Flex
                                        padding="container"
                                        gap="section"
                                        align="center"
                                        justify="between"
                                    >
                                        <Skeleton className="h-[20px] w-[200px]" />
                                        <Skeleton className="h-[20px] w-[60px]" />
                                    </Flex>
                                </Fragment>
                            ))}
                        </Stack>
                    </Stack>
                </Container>
            }
        />
    </div>
);
